
/*
枚举类型
*/

// 接口Code状态
export enum APIResponseCodeType {
    'success' = 1, // 成功
    'error' = 0, // 失败
    'redirect' = -1, // 重定向
    'page' = 2, // 跳转页面
}

// 页面模式
export enum PageMode {
    'ADD' = 'add', // 添加
    'EDIT' = 'edit', // 编辑
}

// 订单管理类型
export enum OrderType {
    'all' = '', // 全部
    'wait' = 0, // 待支付
    'finish' = 1, // 已完成
}

// 物料管理相关枚举

// 物料状态枚举（用于列表页标签）
export enum MaterialStatus {
    'all', // 全部
    'normal', // 正常
    'low_stock', // 库存不足
    'expiring', // 即将过期
    'disabled' // 已停用
}

// 物料类型枚举
export enum MaterialType {
    'normal' = 1, // 普通物料
    'batch' = 2, // 批次管理物料
    'serial' = 3 // 序列号管理物料
}

// 物料状态枚举（用于物料自身状态）
export enum MaterialState {
    'normal' = 1, // 正常
    'disabled' = 2, // 停用
    'obsolete' = 3 // 淘汰
}

// 库存状态枚举
export enum InventoryStatus {
    'normal' = 1, // 正常
    'frozen' = 2, // 冻结
    'pending' = 3 // 待处理
}

// 库存预警类型枚举
export enum InventoryWarningType {
    'low_stock' = 1, // 库存不足
    'overstock' = 2, // 库存积压
    'expiring' = 3 // 即将过期
}

// 物料分类类型枚举
export enum MaterialCategoryType {
    'cleaning' = 1, // 保洁用品
    'repair' = 2, // 维修材料
    'linen' = 3, // 布草类
    'consumable' = 4, // 易耗品
    'equipment' = 5, // 设备配件
    'office' = 6, // 办公用品
    'food' = 7, // 食品饮料
    'other' = 8 // 其他
}

// 供应商类型枚举
export enum SupplierType {
    'cleaning' = 1, // 保洁用品
    'repair' = 2, // 维修材料
    'linen_wash' = 3, // 布草清洗
    'equipment' = 4, // 设备配件
    'office' = 5, // 办公用品
    'food' = 6, // 食品饮料
    'other' = 7 // 其他
}

// 供应商信用等级枚举
export enum SupplierCreditLevel {
    'excellent' = 1, // 优秀
    'good' = 2, // 良好
    'normal' = 3, // 一般
    'poor' = 4, // 较差
    'blacklist' = 5 // 黑名单
}

// 供应商合作状态枚举
export enum SupplierCooperationStatus {
    'cooperating' = 1, // 合作中
    'paused' = 2, // 暂停合作
    'terminated' = 3 // 终止合作
}

// 仓库类型枚举
export enum WarehouseType {
    'central' = 1, // 中心仓
    'store' = 2, // 门店仓
    'virtual' = 3, // 虚拟仓
    'supplier' = 4, // 供应商仓
    'transit' = 5 // 在途仓
}

// 采购订单类型枚举
export enum PurchaseOrderType {
    'standard' = 1, // 标准采购
    'urgent' = 2, // 紧急采购
    'plan' = 3, // 计划采购
    'contract' = 4, // 合同采购
    'transfer' = 5 // 调拨采购
}

// 采购订单状态枚举
export enum PurchaseOrderStatus {
    'draft' = 1, // 草稿
    'submitted' = 2, // 已提交
    'audited' = 3, // 已审核
    'confirmed' = 4, // 已确认
    'canceled' = 5, // 已取消
    'completed' = 6 // 已完成
}

// 入库类型枚举
export enum InboundType {
    'purchase' = 1, // 采购入库
    'return' = 2, // 退货入库
    'transfer_in' = 3, // 调拨入库
    'profit' = 4, // 盘盈入库
    'other_in' = 5 // 其他入库
}

// 出库类型枚举
export enum OutboundType {
    'receive' = 1, // 领用出库
    'sale' = 2, // 销售出库
    'transfer_out' = 3, // 调拨出库
    'loss' = 4, // 盘亏出库
    'scrap' = 5, // 报废出库
    'return_out' = 6 // 退货出库
}

// 盘点类型枚举
export enum CheckType {
    'regular' = 1, // 定期盘点
    'cycle' = 2, // 循环盘点
    'dynamic' = 3, // 动态盘点
    'temporary' = 4 // 临时盘点
}

// 盘点方式枚举
export enum CheckMethod {
    'full' = 1, // 全盘
    'sample' = 2 // 抽盘
}

// 价格调整类型枚举
export enum PriceAdjustmentType {
    'purchase' = 1, // 采购价调整
    'retail' = 2, // 零售价调整
    'member' = 3, // 会员价调整
    'wholesale' = 4 // 批发价调整
}

// 价格类型枚举
export enum PriceType {
    'purchase' = 1, // 采购价
    'contract' = 2, // 合同价
    'promotion' = 3, // 促销价
    'tier' = 4 // 阶梯价
}

// 账单类型枚举
export enum BillType {
    'rent' = 1, // 租金账单
    'utility' = 2, // 水电燃气费账单
    'service' = 3, // 服务费账单
    'deposit' = 4, // 押金账单
    'penalty' = 5, // 违约金账单
    'compensation' = 6, // 维修赔偿账单
    'other' = 7 // 其他费用账单
}

// 账单状态枚举
export enum BillStatus {
    'pending' = 1, // 待支付
    'paid' = 2, // 已支付
    'partially_paid' = 3, // 部分支付
    'overdue' = 4, // 已逾期
    'canceled' = 5, // 已取消
    'refunded' = 6 // 已退款
}

// 支付状态枚举
export enum PaymentStatus {
    'unpaid' = 1, // 未付款
    'partially_paid' = 2, // 部分付款
    'paid' = 3, // 已付款
    'refunded' = 4 // 已退款
}

// 发货状态枚举
export enum DeliveryStatus {
    'unshipped' = 1, // 未发货
    'partially_shipped' = 2, // 部分发货
    'shipped' = 3, // 已发货
    'received' = 4 // 已收货
}

// 发票类型枚举
export enum InvoiceType {
    'normal' = 1, // 普通发票
    'vat' = 2, // 增值税发票
    'none' = 3 // 无发票
}

// 审核状态枚举
export enum AuditStatus {
    'pending' = 1, // 待审批
    'approved' = 2, // 已批准
    'rejected' = 3 // 已拒绝
}

// 调价状态枚举
export enum AdjustStatus {
    'submitted' = 1, // 已提交
    'audited' = 2, // 已审核
    'effective' = 3, // 已生效
    'canceled' = 4 // 已取消
}

// 结算状态枚举
export enum SettlementStatus {
    'pending' = 1, // 待确认
    'confirmed' = 2, // 已确认
    'audited' = 3, // 已审核
    'rejected' = 4 // 已驳回
}

// 结算周期枚举
export enum SettlementCycle {
    'daily' = 1, // 日结
    'weekly' = 2, // 周结
    'biweekly' = 3, // 半月结
    'monthly' = 4, // 月结
    'project' = 5 // 项目结
}

// 计量单位类型枚举
export enum UnitType {
    'piece' = 1, // 个
    'item' = 2, // 件
    'set' = 3, // 套
    'bottle' = 4, // 瓶
    'pack' = 5, // 包
    'roll' = 6, // 卷
    'meter' = 7, // 米
    'kilogram' = 8, // 千克
    'liter' = 9 // 升
}

// 温控要求枚举
export enum TemperatureControl {
    'normal' = 0, // 常温
    'refrigerated' = 1, // 冷藏
    'frozen' = 2, // 冷冻
    'constant' = 3 // 恒温
}

// 安全等级枚举
export enum SecurityLevel {
    'normal' = 1, // 普通
    'important' = 2, // 重要
    'confidential' = 3 // 机密
}
